<div class="page" *ngIf="!showObjectifsSubpage() && !showRapportSubpage()">
  <app-page-site-switcher *ngIf="false"></app-page-site-switcher>
  <!-- DEBUG: Dashboard visible, showCommunicationSubpage = {{ showCommunicationSubpage() }}, activeTab = {{ activeTab() }} -->
  <div class="weekbar">
    <div class="weekbar-left">
      <div class="radio-group">
        <label class="radio-option">
          <input type="radio" name="period" value="week" [checked]="periodMode() === 'week'" (change)="setPeriodMode('week')">
          <span class="radio-label">{{ 'qualite.periodToggle.week' | translate }}</span>
        </label>
        <label class="radio-option">
          <input type="radio" name="period" value="month" [checked]="periodMode() === 'month'" (change)="setPeriodMode('month')">
          <span class="radio-label">{{ 'qualite.periodToggle.month' | translate }}</span>
        </label>
      </div>

      <label class="pill-select pill-wide" *ngIf="periodMode() === 'week'" (click)="toggleWeek($event)">
        <span class="pill-prefix">{{ 'qualite.periodToggle.week' | translate }}</span>
        <span class="pill-value">{{ week() }}</span>
        <span class="pill-chev">
          <svg viewBox="0 0 20 20" width="14" height="14">
            <path d="M5.5 7.75a1 1 0 0 1 1.62-.78l2.88 2.36 2.88-2.36a1 1 0 1 1 1.26 1.55l-3.5 2.87a1.5 1.5 0 0 1-1.88 0l-3.5-2.87a1 1 0 0 1-.76-.77z" fill="currentColor"/>
          </svg>
        </span>
        <span class="pill-sublabel">{{ weekLabel() }}</span>
        <div class="dropdown-panel dropdown-panel--wide" *ngIf="weekOpen()" (click)="$event.stopPropagation()">
          <div class="dropdown-header">{{ 'qualite.weekPicker.chooseLabel' | translate }}</div>
          <ul class="dropdown-list">
            <li class="dropdown-item" *ngFor="let w of weeks()" [class.selected]="w===week()" (click)="selectWeek(w)">{{ w }}</li>
          </ul>
        </div>
      </label>

      <label class="pill-select" *ngIf="periodMode() === 'month'" (click)="toggleMonth($event)">
        <span class="pill-prefix">{{ 'qualite.periodToggle.month' | translate }}</span>
        <span class="pill-value">{{ currentMonthLabel() }}</span>
        <span class="pill-chev">
          <svg viewBox="0 0 20 20" width="14" height="14">
            <path d="M5.5 7.75a1 1 0 0 1 1.62-.78l2.88 2.36 2.88-2.36a1 1 0 1 1 1.26 1.55l-3.5 2.87a1.5 1.5 0 0 1-1.88 0l-3.5-2.87a1 1 0 0 1-.76-.77z" fill="currentColor"/>
          </svg>
        </span>

        <div class="dropdown-panel dropdown-panel--wide" *ngIf="monthOpen()" (click)="$event.stopPropagation()">
          <div class="dropdown-header">{{ 'qualite.monthPicker.chooseLabel' | translate }}</div>
          <ul class="dropdown-list">
            <li class="dropdown-item" *ngFor="let m of months()" [class.selected]="m.value===currentMonth()" (click)="selectMonth(m.value)">{{ m.label }}</li>
          </ul>
        </div>
      </label>
    </div>

    <div class="weekbar-right">
      <button class="refresh-button" (click)="refreshData()" [title]="'qualite.refresh.tooltip' | translate" [disabled]="isRefreshing()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="refresh-icon" [class.spinning]="isRefreshing()">
          <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
          <path d="M21 3v5h-5"/>
          <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
          <path d="M3 21v-5h5"/>
        </svg>
        <span>{{ 'qualite.refresh.label' | translate }}</span>
      </button>
      <div class="tabs-nav">
        <button type="button" class="tab-btn active" *ngIf="!useOrgWideView() && isAdmin">
          <img src="/assets/qualite.svg" alt="" width="18" height="18" />
          <span>{{ 'qualite.tabs.quality' | translate }}</span>
        </button>
        <span class="tab-separator" *ngIf="!useOrgWideView() && isAdmin">|</span>
        <button type="button" class="tab-btn" (click)="openObjectifsSubpage()" *ngIf="!useOrgWideView() && isAdmin">
          <img src="/assets/objectifs.svg" alt="" width="18" height="18" />
          <span>{{ 'qualite.tabs.administration' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- 6 cards alignées horizontalement avec titres de familles -->
  <div class="cards-container">
    <!-- Famille 1: Satisfaction & Perception -->
    <div class="card family-1">
      <div class="card-header">
        <div class="card-icon">⭐</div>
        <h4>{{ 'qualite.cards.satisfaction.title' | translate }}</h4>
      </div>
      <div class="card-content">
        <div class="card-main-value">
          <ng-container *ngIf="avgScore() !== null; else showFeedbackCount">
            {{ avgScore() | number:'1.1-1' }}<span class="unit">/5</span>
          </ng-container>
          <ng-template #showFeedbackCount>
            <ng-container *ngIf="periodMode() === 'month' && getFeedbackCount() > 0; else showNA">
              {{ getFeedbackCount() }}<span class="unit"> {{ 'qualite.cards.reviewsUnit' | translate }}</span>
            </ng-container>
            <ng-template #showNA>n/a</ng-template>
          </ng-template>
        </div>
      </div>
      <div class="card-badge" [ngClass]="getSatisfactionBadgeClass()">{{ getSatisfactionBadgeText() }}</div>
    </div>

    <div class="card family-1">
      <div class="family-title">{{ 'qualite.families.satisfactionPerception' | translate }}</div>
      <div class="card-header">
        <div class="card-icon">📊</div>
        <h4>{{ 'qualite.cards.participation.title' | translate }}</h4>
      </div>
      <div class="card-content">
        <div class="card-main-value">{{ participationRate() || 'n/a' }}<span class="unit" *ngIf="participationRate()">%</span></div>
      </div>
      <div class="card-badge" [ngClass]="getParticipationBadgeClass()">{{ getParticipationBadgeText() }}</div>
    </div>

    <div class="card family-1">
      <div class="card-header">
        <div class="card-icon">⏱️</div>
        <h4>{{ 'qualite.cards.waitingPerception.title' | translate }}</h4>
      </div>
      <div class="card-content">
        <div class="card-main-value">{{ getWaitingPerceptionText() }}</div>
      </div>
      <div class="card-badge" [ngClass]="getWaitingBadgeClass()" *ngIf="getWaitingPerceptionText() !== 'n/a'">{{ getWaitingBadgeText() }}</div>
    </div>

    <!-- Famille 2: Qualité / Conformité -->
    <div class="card family-2">
      <div class="card-header">
        <div class="card-icon">📱</div>
        <h4>{{ 'qualite.cards.qrScan.title' | translate }}</h4>
      </div>
      <div class="card-content">
        <div class="card-main-value">{{ scanCount() !== null ? scanCount() : 'n/a' }}</div>
      </div>
      <div class="card-badge" [ngClass]="getScanBadgeClass()">{{ getScanBadgeText() }}</div>
    </div>

    <div class="card family-2">
      <div class="family-title">{{ 'qualite.families.qualityCompliance' | translate }}</div>
      <div class="card-header">
        <div class="card-icon">💬</div>
        <h4>{{ 'qualite.cards.complaintRate.title' | translate }}</h4>
      </div>
      <div class="card-content">
        <div class="card-main-value">{{ complaintRate() | number:'1.1-1' }}<span class="unit">%</span></div>
      </div>
      <div class="card-badge" [ngClass]="getComplaintBadgeClass()">{{ getComplaintBadgeText() }}</div>
    </div>

    <div class="card family-2">
      <div class="card-header">
        <div class="card-icon">🚀</div>
        <h4>{{ 'qualite.cards.responseTime.title' | translate }}</h4>
      </div>
      <div class="card-content">
        <div class="card-main-value">{{ getResponseTimeDisplay() || 'n/a' }}</div>
      </div>
      <div class="card-badge" [ngClass]="getResponseTimeBadgeClass()">{{ getResponseTimeBadgeText() }}</div>
    </div>

    <div class="card family-2" style="display: none;">
      <div class="card-header">
        <div class="card-icon">📈</div>
        <h4>{{ 'qualite.cards.action.title' | translate }}</h4>
      </div>
      <div class="card-content">
        <div class="card-main-value">{{ actionCount() !== null ? actionCount() : 'n/a' }}</div>
      </div>
      <div class="card-badge" [ngClass]="getActionBadgeClass()">{{ getActionBadgeText() }}</div>
    </div>
  </div>

  <!-- Nom de l'établissement avec bouton rapport (mode site unique uniquement) -->
  @if (!useOrgWideView() && session.selectedId()) {
    <div class="establishment-name">
      <h2>{{ getEstablishmentName(session.selectedId()!) }}</h2>
      @if (isAdmin) {
        <button type="button" class="btn-download" [class.disabled]="periodMode() === 'week'" [disabled]="periodMode() === 'week'" (click)="openRapportSubpage()">
          <img src="/assets/download.svg" alt="" width="18" height="18" />
          <span>{{ 'qualite.establishment.monthlyReportButton' | translate }}</span>
        </button>
      }
    </div>
  }

  <!-- 3 blocs de graphiques : masqués dans l'intégration agrégée /statistiques
       (inline sans forceSingleSite) — gardés pour /site et pour /qualite en direct. -->
  @if (!inline || forceSingleSite) {
  <div class="charts-container">
    <div class="chart-block">
      <div class="chart-header">
        <h3>{{ 'qualite.charts.participation.title' | translate }}</h3>
      </div>
      <div class="chart-content">
        <svg width="100%" height="200" viewBox="0 0 300 200">
          <!-- Échelle Y -->
          <text x="10" y="175" font-size="9" fill="#9CA3AF" text-anchor="end">0%</text>
          <text x="10" y="135" font-size="9" fill="#9CA3AF" text-anchor="end">25%</text>
          <text x="10" y="95" font-size="9" fill="#9CA3AF" text-anchor="end">50%</text>
          <text x="10" y="55" font-size="9" fill="#9CA3AF" text-anchor="end">75%</text>
          <text x="10" y="25" font-size="9" fill="#9CA3AF" text-anchor="end">100%</text>
          <!-- Lignes de grille -->
          <line x1="15" y1="150" x2="295" y2="150" stroke="#F1F5F9" stroke-width="1"/>
          <line x1="15" y1="110" x2="295" y2="110" stroke="#F1F5F9" stroke-width="1"/>
          <line x1="15" y1="70" x2="295" y2="70" stroke="#F1F5F9" stroke-width="1"/>
          <line x1="15" y1="30" x2="295" y2="30" stroke="#F1F5F9" stroke-width="1"/>
          <!-- Barres dynamiques -->
          <rect *ngFor="let value of participationHistory(); let i = index"
                [attr.x]="getParticipationBarX(i)"
                [attr.y]="150 - (value * 1.4)"
                [attr.width]="getParticipationBarWidth()"
                [attr.height]="value * 1.4"
                fill="#10B981"/>
          <!-- Valeurs sur les barres -->
          <text *ngFor="let value of participationHistory(); let i = index"
                [attr.x]="getParticipationBarX(i) + getParticipationBarWidth() / 2"
                [attr.y]="Math.max(20, 145 - (value * 1.4))"
                text-anchor="middle"
                font-size="10"
                fill="#374151"
                font-weight="600">
            {{ mathRound(value) }}%
          </text>
        </svg>
      </div>
      <div class="chart-legend">
        <ng-container *ngIf="periodMode() === 'week'">
          <span *ngFor="let label of getWeekLabels(); let i = index" class="label-stacked">
            <span class="label-day">{{ label.day }}</span>
            <span class="label-num">{{ label.num }}</span>
          </span>
        </ng-container>
        <ng-container *ngIf="periodMode() === 'month'">
          <span *ngFor="let label of getMonthLabels(); let i = index">{{ label }}</span>
        </ng-container>
      </div>
    </div>

    <div class="chart-block">
      <div class="chart-header">
        <h3>{{ 'qualite.charts.complaintRate.title' | translate }}</h3>
      </div>
      <div class="chart-content">
        <svg width="100%" height="200" viewBox="0 0 300 200">
          <!-- Échelle Y -->
          <text x="10" y="155" font-size="9" fill="#9CA3AF" text-anchor="end">0</text>
          <text x="10" y="125" font-size="9" fill="#9CA3AF" text-anchor="end">{{ getComplaintScaleLabel(25) }}</text>
          <text x="10" y="95" font-size="9" fill="#9CA3AF" text-anchor="end">{{ getComplaintScaleLabel(50) }}</text>
          <text x="10" y="65" font-size="9" fill="#9CA3AF" text-anchor="end">{{ getComplaintScaleLabel(75) }}</text>
          <text x="10" y="35" font-size="9" fill="#9CA3AF" text-anchor="end">{{ getComplaintScaleLabel(100) }}</text>
          <!-- Lignes de grille -->
          <line x1="15" y1="150" x2="295" y2="150" stroke="#F1F5F9" stroke-width="1"/>
          <line x1="15" y1="120" x2="295" y2="120" stroke="#F1F5F9" stroke-width="1"/>
          <line x1="15" y1="90" x2="295" y2="90" stroke="#F1F5F9" stroke-width="1"/>
          <line x1="15" y1="60" x2="295" y2="60" stroke="#F1F5F9" stroke-width="1"/>
          <line x1="15" y1="30" x2="295" y2="30" stroke="#F1F5F9" stroke-width="1"/>
          <!-- Courbe dynamique -->
          <polyline [attr.points]="getComplaintChartPoints()" stroke="#EF4444" stroke-width="3" fill="none"/>
          <circle *ngFor="let value of complaintHistory(); let i = index"
                  [attr.cx]="getComplaintPointX(i)"
                  [attr.cy]="getComplaintPointY(value)"
                  r="4"
                  fill="#EF4444"/>
          <!-- Valeurs sur les points -->
          <text *ngFor="let value of complaintHistory(); let i = index"
                [attr.x]="getComplaintPointX(i)"
                [attr.y]="getComplaintPointY(value) - 8"
                text-anchor="middle"
                font-size="10"
                fill="#374151"
                font-weight="600">
            {{ mathRoundDecimal(value) }}%
          </text>
        </svg>
      </div>
      <div class="chart-legend">
        <ng-container *ngIf="periodMode() === 'week'">
          <span *ngFor="let label of getWeekLabels(); let i = index" class="label-stacked">
            <span class="label-day">{{ label.day }}</span>
            <span class="label-num">{{ label.num }}</span>
          </span>
        </ng-container>
        <ng-container *ngIf="periodMode() === 'month'">
          <span *ngFor="let label of getMonthLabels(); let i = index">{{ label }}</span>
        </ng-container>
      </div>
    </div>

    <div class="chart-block">
      <div class="chart-header">
        <h3>{{ 'qualite.charts.waitingPerception.title' | translate }}</h3>
      </div>
      <div class="chart-content">
        <svg width="100%" height="200" viewBox="0 0 300 200">
          <!-- Camembert avec ombres -->
          <defs>
            <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="2" dy="2" stdDeviation="3" flood-color="rgba(0,0,0,0.1)"/>
            </filter>
          </defs>

          <g transform="translate(150,100)">
            <!-- Courte 100% -->
            <ng-container *ngIf="waitingChartAngles().courte >= 360">
              <circle r="80" fill="#10B981" stroke="white" stroke-width="2" filter="url(#shadow)"/>
            </ng-container>
            <!-- Moyenne 100% -->
            <ng-container *ngIf="waitingChartAngles().moyenne >= 360">
              <circle r="80" fill="#F59E0B" stroke="white" stroke-width="2" filter="url(#shadow)"/>
            </ng-container>
            <!-- Longue 100% -->
            <ng-container *ngIf="waitingChartAngles().longue >= 360">
              <circle r="80" fill="#EF4444" stroke="white" stroke-width="2" filter="url(#shadow)"/>
            </ng-container>
            <!-- Segments partiels -->
            <ng-container *ngIf="waitingChartAngles().courte > 0 && waitingChartAngles().courte < 360">
              <path [attr.d]="getPiePath(-1.57, -1.57 + (waitingChartAngles().courte * Math.PI / 180))"
                    fill="#10B981" stroke="white" stroke-width="2" filter="url(#shadow)"/>
            </ng-container>
            <ng-container *ngIf="waitingChartAngles().moyenne > 0 && waitingChartAngles().moyenne < 360">
              <path [attr.d]="getPiePath(-1.57 + (waitingChartAngles().courte * Math.PI / 180), -1.57 + ((waitingChartAngles().courte + waitingChartAngles().moyenne) * Math.PI / 180))"
                    fill="#F59E0B" stroke="white" stroke-width="2" filter="url(#shadow)"/>
            </ng-container>
            <ng-container *ngIf="waitingChartAngles().longue > 0 && waitingChartAngles().longue < 360">
              <path [attr.d]="getPiePath(-1.57 + ((waitingChartAngles().courte + waitingChartAngles().moyenne) * Math.PI / 180), -1.57 + (360 * Math.PI / 180))"
                    fill="#EF4444" stroke="white" stroke-width="2" filter="url(#shadow)"/>
            </ng-container>
          </g>

          <!-- Texte central -->
          <circle cx="150" cy="100" r="40" fill="white" stroke="#E5E7EB" stroke-width="1"/>
          <text x="150" y="95" text-anchor="middle" font-size="18" font-weight="bold" [attr.fill]="getWaitingPerceptionColor()">{{ waitingCenterText() }}</text>
          <text x="150" y="112" text-anchor="middle" font-size="13" fill="#64748B">{{ getWaitingPerceptionText() }}</text>
        </svg>
      </div>
      <div class="chart-legend">
        <span><span class="legend-dot" style="background: #10B981"></span>{{ 'qualite.waitingLegend.short' | translate }} {{ waitingPercentages().courte }}%</span>
        <span><span class="legend-dot" style="background: #F59E0B"></span>{{ 'qualite.waitingLegend.medium' | translate }} {{ waitingPercentages().moyenne }}%</span>
        <span><span class="legend-dot" style="background: #EF4444"></span>{{ 'qualite.waitingLegend.long' | translate }} {{ waitingPercentages().longue }}%</span>
      </div>
    </div>
  </div>
  }

</div>

<!-- Fil d'Ariane + onglets pour la sous-page Objectifs -->
<div class="weekbar" *ngIf="showObjectifsSubpage()">
  <div class="weekbar-left" *ngIf="!inline">
    <div class="breadcrumb">
      <button class="breadcrumb-back" (click)="closeObjectifsSubpage()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'common.actions.back' | translate }}
      </button>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'qualite.breadcrumb.quality' | translate }}</span>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'qualite.breadcrumb.administration' | translate }}</span>
    </div>
  </div>
  <div class="weekbar-right">
    <div class="tabs-nav">
      <button type="button" class="tab-btn" [class.active]="activeTab() === 'objectifs'" (click)="setActiveTab('objectifs')">
        <img src="/assets/objectifs.svg" alt="" width="18" height="18" />
        <span>{{ 'qualite.tabs.objectifs' | translate }}</span>
      </button>
      <span class="tab-separator">|</span>
      <button type="button" class="tab-btn" [class.active]="activeTab() === 'communication'" (click)="setActiveTab('communication')">
        <img src="/assets/parametres.svg" alt="" width="18" height="18" />
        <span>{{ 'qualite.tabs.texts' | translate }}</span>
      </button>
      <span class="tab-separator">|</span>
      <button type="button" class="tab-btn" [class.active]="activeTab() === 'formulaire'" (click)="setActiveTab('formulaire')">
        <img src="/assets/objectifs.svg" alt="" width="18" height="18" />
        <span>{{ 'qualite.tabs.formulaire' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Sous-page Objectifs -->
<div *ngIf="showObjectifsSubpage() && activeTab() === 'objectifs'">
  <app-objectifs></app-objectifs>
</div>

<!-- Sous-page Communication -->
<div *ngIf="showObjectifsSubpage() && showCommunicationSubpage()">
  <div class="page" style="background: transparent; margin-top: 16px;">
    <div class="page-grid" style="display: grid; grid-template-columns: 1fr; gap: 16px; align-items: start; max-width: 1500px;">
      <app-message [(message)]="messageRapide"></app-message>
    </div>
  </div>
</div>

<!-- Sous-page Formulaire -->
<div *ngIf="showObjectifsSubpage() && showFormulaireSubpage()">
  <app-formulaire></app-formulaire>
</div>

<!-- Fil d'Ariane pour la sous-page Rapport -->
<div class="weekbar" *ngIf="showRapportSubpage() && !inline">
  <div class="weekbar-left">
    <div class="breadcrumb">
      <button class="breadcrumb-back" (click)="closeRapportSubpage()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'common.actions.back' | translate }}
      </button>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'qualite.breadcrumb.quality' | translate }}</span>
      <span class="breadcrumb-separator">•</span>
      <span class="breadcrumb-current">{{ 'qualite.breadcrumb.report' | translate }}</span>
    </div>
  </div>
</div>

<!-- Sous-page Rapport -->
<div *ngIf="showRapportSubpage()">
  <app-rapport></app-rapport>
</div>
